import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../contexts/AuthContext";
import { guardarPDF } from "../pages/compras/helpers";

// Fix EB (2026-09-23): "permitir exportar en excel y PDF desde este módulo, a modo de
// generar informes o reportes filtrados". Se exporta exactamente lo que muestra la tabla,
// con los filtros aplicados. El PDF se arma en el navegador (jsPDF, como el resto del
// ERP); el Excel lo arma el backend (POST /api/treasury/exportar-tabla-excel).
//   columnas: [{ l: "Título", num: true }]   filas: [[v1, v2, ...]]   totales: [v1, v2, ...]

const CEN_BLUE = [46, 109, 164];
const numPY = (v) => Math.round(Number(v) || 0).toLocaleString("es-PY");
const vacio = (v) => v === null || v === undefined || v === "";

// "2026-09-23" → "23/09/2026"
export function fechaReporte(s) {
  const t = String(s || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(t) ? t.split("-").reverse().join("/") : t;
}

// Fix FO (2026-10-09): "Vista previa" (CEN, reunión de Finanzas: ver el reporte antes de
// exportarlo). Abre el mismo PDF en una pestaña nueva, sin descargarlo.
export function verPdf(doc, archivo) {
  const url = URL.createObjectURL(doc.output("blob"));
  if (!window.open(url, "_blank")) { URL.revokeObjectURL(url); guardarPDF(doc, archivo); }
}

export function exportarTablaPdf({ titulo, filtros = "", columnas, filas, totales = null, archivo, ver = false }) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pw = doc.internal.pageSize.getWidth();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(...CEN_BLUE);
  doc.text(titulo, 10, 13);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(90, 90, 90);
  const pie = `${filas.length} registro${filas.length === 1 ? "" : "s"} · Generado el ${new Date().toLocaleString("es-PY")}`;
  doc.text(filtros ? `${filtros} · ${pie}` : pie, 10, 19, { maxWidth: pw - 20 });
  const columnStyles = {};
  columnas.forEach((c, i) => { if (c.num) columnStyles[i] = { halign: "right" }; });
  autoTable(doc, {
    startY: 24,
    head: [columnas.map(c => c.l)],
    body: filas.map(f => columnas.map((c, i) => (c.num ? (Number(f[i]) ? numPY(f[i]) : "—") : (vacio(f[i]) ? "—" : String(f[i]))))),
    foot: totales ? [columnas.map((c, i) => (vacio(totales[i]) ? "" : (c.num && typeof totales[i] === "number" ? numPY(totales[i]) : String(totales[i]))))] : undefined,
    styles: { fontSize: 7, cellPadding: 1.5, overflow: "linebreak" },
    headStyles: { fillColor: CEN_BLUE, textColor: [255, 255, 255], fontStyle: "bold" },
    footStyles: { fillColor: [220, 235, 245], textColor: [40, 40, 40], fontStyle: "bold" },
    alternateRowStyles: { fillColor: [245, 249, 255] },
    columnStyles,
    margin: { left: 10, right: 10 },
  });
  if (ver) verPdf(doc, archivo);
  else guardarPDF(doc, archivo);
}

export async function exportarTablaExcel({ titulo, filtros = "", columnas, filas, totales = null, archivo }) {
  const res = await axios.post(`${API}/treasury/exportar-tabla-excel`,
    { titulo, filtros, columnas, filas, totales }, { withCredentials: true, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = archivo;
  link.click();
  URL.revokeObjectURL(url);
}

// tipo: "excel" | "pdf" | "ver" (vista previa del PDF, Fix FO). reporte: { titulo, filtros, columnas, filas, totales, archivo (sin extensión) }
export async function exportarReporte(tipo, reporte, setExportando) {
  if (!reporte.filas.length) { toast.error("No hay filas para exportar con esos filtros"); return; }
  setExportando(tipo);
  try {
    if (tipo === "pdf" || tipo === "ver") exportarTablaPdf({ ...reporte, archivo: `${reporte.archivo}.pdf`, ver: tipo === "ver" });
    else await exportarTablaExcel({ ...reporte, archivo: `${reporte.archivo}.xlsx` });
  } catch {
    toast.error("No se pudo generar el archivo");
  } finally {
    setExportando("");
  }
}
